import { authentication, app } from "@microsoft/teams-js";

async function getAccessToken(): Promise<string> {
    await app.initialize();

    const authTokenRequest = {
        resources: []
    };
    return authentication.getAuthToken(authTokenRequest).then((token: string) => {
        return token;
    }).catch((error: string) => {
        return "Error getting token: " + error
    })
}

async function fetchWrapper (input: RequestInfo, init?: RequestInit): Promise<Response> {
    const token = await getAccessToken();
    if (!!!init) {
        init = { }
    }

    init.headers = { ...init.headers, "Authorization": "Bearer " + token };
    return await fetch(input, init);;
}

export default fetchWrapper;